import React from 'react';
import styles from './BusinessAreaSelection.module.scss';
import { ChipsGroup } from 'app/components';
import {
  getBusinessArea,
  useAppSelector,
  useAppDispatch,
  setBusinessArea,
  setService,
  getBootstrapApp,
  setCurrentFile,
  setInputSize
} from 'app/redux';
import { smoothScrollingToAnchor } from 'app/utils';

export const BusinessAreaSelection: React.FC = () => {
  const dispatch = useAppDispatch();
  const bootstrap = useAppSelector(getBootstrapApp);
  const currentBusinessArea = useAppSelector(getBusinessArea);
  const businessAreas = bootstrap.businessAreas;

  const handleBusinessAreaSelection = ({
    status,
    value
  }: {
    status: boolean;
    value: string;
  }): void => {
    dispatch(setBusinessArea(value));
    dispatch(setService(undefined));
    dispatch(setCurrentFile(undefined));
    dispatch(setInputSize(undefined));
    if (currentBusinessArea === value && !status)
      dispatch(setBusinessArea(undefined));
    if (status) smoothScrollingToAnchor('services');
  };

  return (
    <>
      <div className={styles['business-area']} id="businessareas">
        <h3 className={styles['heading-3']}>1. Choose your business area</h3>
        <div className={styles.wrapper}>
          <div className={styles['chips-area']}>
            <div className={styles.chips}>
              {
                <ChipsGroup
                  chipElements={businessAreas}
                  selected={currentBusinessArea}
                  onClick={handleBusinessAreaSelection}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
